import { IUserTagging } from "../components/user-tagging/user-tagging-module";
import { GridComponentParams, GridColumn, Editing } from "../components/grid/grid-module";
import { DateTimePickerComponentParams, DateTimePickerComponent } from "../components/date-time-picker/date-time-picker-module";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
class BaoDemo {
    customers = ko.observableArray([{
            "ID": 1,
            "CompanyName": "Super Mart of the West",
            "Address": "702 SW 8th Street",
            "City": "Bentonville",
            "State": "Arkansas",
            "Zipcode": 72716,
            "Phone": "(800) 555-2797",
            "Fax": "(800) 555-2171",
            "Website": "http://www.nowebsitesupermart.com"
        }, {
            "ID": 2,
            "CompanyName": "Electronics Depot",
            "Address": "2455 Paces Ferry Road NW",
            "City": "Atlanta",
            "State": "Georgia",
            "Zipcode": 30339,
            "Phone": "(800) 595-3232",
            "Fax": "(800) 595-3231",
            "Website": "http://www.nowebsitedepot.com"
        }, {
            "ID": 3,
            "CompanyName": "K&S Music",
            "Address": "1000 Nicllet Mall",
            "City": "Minneapolis",
            "State": "Minnesota",
            "Zipcode": 55403,
            "Phone": "(612) 304-6073",
            "Fax": "(612) 304-6074",
            "Website": "http://www.nowebsitemusic.com"
        }, {
            "ID": 4,
            "CompanyName": "Tom's Club",
            "Address": "999 Lake Drive",
            "City": "Issaquah",
            "State": "Washington",
            "Zipcode": 98027,
            "Phone": "(800) 955-2292",
            "Fax": "(800) 955-2293",
            "Website": "http://www.nowebsitetomsclub.com"
        }, {
            "ID": 5,
            "CompanyName": "E-Mart",
            "Address": "3333 Beverly Rd",
            "City": "Hoffman Estates",
            "State": "Illinois",
            "Zipcode": 60179,
            "Phone": "(847) 286-2500",
            "Fax": "(847) 286-2501",
            "Website": "http://www.nowebsiteemart.com"
        }]);
    columns: GridColumn[] = [{ caption: "CompanyName", dataField: "CompanyName" },
        { caption: "City", dataField: "City" },
        { caption: "State", dataField: "State" },
        { caption: "Phone", dataField: "Phone" },
        { caption: "Fax", dataField: "Fax" },
        { caption: "Website", dataField: "Website" }];
    editing: Editing = {
        mode: 'cell',
        allowUpdating: true
    };
    showBorders = true;
    gridData: GridComponentParams;
    dateTimePicker: DateTimePickerComponentParams;
    pickerValue: KnockoutObservable<any> = ko.observable(new Date());
    constructor(public TabPage: any) {
        this.gridData = {
            dataSource: this.customers,
            columns: this.columns,
            editing: this.editing,
            showBorders: this.showBorders,
            allowColumnReordering: true,
            allowColumnResizing: true,
            groupPanel: {
                visible: true
            }
        };
        this.dateTimePicker = {
            acceptCustomValue: false, applyButtonText: "Ok", cancelButtonText: "Cancel", type: "datetime", pickerType: "calendar", value: this.pickerValue, showDropdownButton: true
        };
    }
    RawValue: KnockoutObservable<string> = ko.observable("");
    DisplayValue: KnockoutObservable<string> = ko.observable("");
    UserTaggingList: KnockoutObservableArray<IUserTagging> = ko.observableArray();
    init() {
        let d = $.Deferred<void>();
        d.resolve();
        this.UserTaggingList.subscribe(newValue => {
            console.log(newValue);
        });
        this.customers.subscribe((newValue) => {
            console.log('customer change');
            console.log(this.customers());
        });
        this.pickerValue.subscribe((newValue) => {
            console.log("Value change");
            console.log(this.pickerValue());
        });
        return d.promise();
    }
    Loading = ko.observable(false);
    LoadingTest() {
        this.Loading(true);
        setTimeout(() => {
            this.Loading(false);
        }, 5000);
    }
    loaded() {
    }
    SaveUserTaggings() {
        Bao.post("UserTagging/SaveUserTaggings", JSON.stringify(this.UserTaggingList()), (result) => {
        });
    }
}
export default BaoDemo;